import {useMemberStore} from '~/store/member/index.js'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  // API 호출을 위한 공통 함수
  const apiClient = async (path, options = {}) => {
    // 인증상태 체크
    const isAuthenticated = useMemberStore().isAuthenticated
    if (isAuthenticated) {
      const accessToken = useMemberStore().accessToken
      options.headers = {
        Authorization: `Bearer ${accessToken}`
      }
    }

    return await $fetch(path, {
      baseURL: config.public.apiBaseUrl,
      ...options
    })
  }
  return {
    provide: {
      apiClient
    }
  }
})
